import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    ExpandTopMenuPanel,
    ExpandTopMenuPanelItemSelect,
    FilterButton,
    StowageTabsWrapper,
    TankPlanTopMenuContainer,
} from './TankPlanTopMenu.styles';
import { useStowageStore } from 'src/context/StowageContext';
import { TabButton, TabText } from 'src/styles/button.style';
import { TankPlanCondition } from 'src/enums/stowage/tankPlanCondition';
import FilterPanelComponent from '../../common/TankPlanFilterPanel';
import { RedIcon } from 'src/components/ui/status-icon/VerificationIcon.styles';

const TankPlanTopMenu: React.FC = () => {
    const {
        selectedTankPlanCondition,
        setSelectedTankPlanCondition,
        isTankPlanFilterPanelOpen,
        setIsTankPlanFilterPanelOpen,
        selectedTankPlanFilters,
        setMouseClickPosition,
    } = useStowageStore();

    const [numberOfTankPlanFiltersActive, setNumberOfTankPlanFiltersActive] = useState<number>(0);

    useEffect(() => {
        let numFiltersActive = 0;
        let numConditionsActive = 0;
        if (selectedTankPlanCondition !== TankPlanCondition.Arrival && selectedTankPlanCondition !== TankPlanCondition.Departure) {
            numConditionsActive = 1;
        } else {
            numConditionsActive = 0;
        }

        if (selectedTankPlanFilters.length > 0) {
            numFiltersActive = 1;
        } else {
            numFiltersActive = 0;
        }

        setNumberOfTankPlanFiltersActive(numFiltersActive + numConditionsActive);
    }, [selectedTankPlanCondition, selectedTankPlanFilters]);

    const onOpenTankPlanFilterPanel = (e: React.MouseEvent) => {
        // Store click position before opening the panel
        setMouseClickPosition({
            top: e.clientY,
            left: e.clientX,
        });
        setIsTankPlanFilterPanelOpen(!isTankPlanFilterPanelOpen);
    };

    return (
        <TankPlanTopMenuContainer>
            <ExpandTopMenuPanel>
                <ExpandTopMenuPanelItemSelect>
                    <StowageTabsWrapper tabs={'125px 125px'}>
                        <TabButton
                            className="first tabs-button"
                            isSelected={selectedTankPlanCondition === TankPlanCondition.Arrival}
                            onClick={() => setSelectedTankPlanCondition(TankPlanCondition.Arrival)}
                        >
                            <TabText>Arrival</TabText>
                        </TabButton>
                        <TabButton
                            className="last tabs-button"
                            isSelected={selectedTankPlanCondition === TankPlanCondition.Departure}
                            onClick={() => setSelectedTankPlanCondition(TankPlanCondition.Departure)}
                        >
                            <TabText>Departure</TabText>
                        </TabButton>
                    </StowageTabsWrapper>
                    <FilterButton onClick={(e) => onOpenTankPlanFilterPanel(e)}>
                        <FontAwesomeIcon icon="filter" />
                        {numberOfTankPlanFiltersActive > 0 && (
                            <RedIcon className="red-icon" title={'Tank plan filters active'}>
                                {numberOfTankPlanFiltersActive}
                            </RedIcon>
                        )}
                    </FilterButton>
                    <FilterPanelComponent />
                </ExpandTopMenuPanelItemSelect>
            </ExpandTopMenuPanel>
        </TankPlanTopMenuContainer>
    );
};

export default TankPlanTopMenu;
